import classNames from 'classnames';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {StudySchemaQuery_studySchema_StudySchemaNode_entryTemplates as EntryTemplateIconOrInaccessibleInfo} from './__generated/StudySchemaQuery';
import EntryTemplatesFieldChip from './EntryTemplatesFieldChip';

export interface TagEntryTemplatesProps {
  entryTemplates: Array<EntryTemplateIconOrInaccessibleInfo>;
}

function TagEntryTemplates({entryTemplates}: TagEntryTemplatesProps): JSX.Element | null {
  return entryTemplates.length === 0 ? null : (
    <div className="simpleDivTable-row">
      <div className={classNames('simpleDivTable-cell', 'u-flex-display')}>
        {entryTemplates.flatMap((template) => {
          if (!isInaccessible(template)) {
            return [<EntryTemplatesFieldChip name={template.name} key={template.id} />];
          } else {
            return [<EntryTemplatesFieldChip name="No access" key={template.invalidId} />];
          }
        })}
      </div>
    </div>
  );
}

export default TagEntryTemplates;
